import { Prisma } from '@prisma/client';

export type ModelName = Prisma.ModelName;

export type ModelNamePick<T extends ModelName> = T;

export const ViewModels: Partial<Record<ModelName, ModelName>> = {
  AccountView: 'Account',
  OrganisationView: 'Organisation',
  IndividualView: 'Individual',
  MemberView: 'Member',
  RecurringTaskView: 'RecurringTask',
  ServiceView: 'Service',
  TaskView: 'Task',
};

export const ModelViews: Partial<Record<ModelName, ModelName>> = {
  Account: 'AccountView',
  Organisation: 'OrganisationView',
  Individual: 'IndividualView',
  Member: 'MemberView',
  RecurringTask: 'RecurringTaskView',
  Service: 'ServiceView',
  Task: 'TaskView',
};
